import { render, staticRenderFns } from "./CommonTags.vue?vue&type=template&id=214883aa&scoped=true&"
import script from "./CommonTags.vue?vue&type=script&lang=ts&"
export * from "./CommonTags.vue?vue&type=script&lang=ts&"
import style0 from "./CommonTags.vue?vue&type=style&index=0&id=214883aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214883aa",
  null
  
)

export default component.exports